import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrl } from '../../utilities/api-config';


@Injectable({
  providedIn: 'root'
})
export class AuthHeaderInterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    let accesToken = '';
    if (request.url.includes(ApiUrl)) {
      accesToken = localStorage.getItem("JWTtoken")
        ? "Bearer " + localStorage.getItem("JWTtoken")
        : "null";
      } else {
        accesToken = localStorage.getItem("TokenPKCE")
        ? "Bearer " + localStorage.getItem("TokenPKCE")
        : "null";
      }
      const myAuthToken = accesToken;
      const authReq = request.clone({
        setHeaders: { Authorization: myAuthToken },
      });
    return next.handle(authReq);
  }
}